import { apiClient, type SiteExEntity } from '@/libs/api'

export type FetchSiteQuery = {
  tenantKey: string
  siteId: number
}

export const fetchSite = async (
  { tenantKey, siteId }: FetchSiteQuery,
  signal?: AbortSignal
): Promise<SiteExEntity> => {
  const { data } = await apiClient._tenant(tenantKey).sites._id(siteId).$get({
    config: { signal }
  })
  return data
}
